export const demo_form = require("./1-prestart-form.json");

export const forms = [
  require("./1-prestart-form.json"),
  require("./linkforce/end-of-shut-inspection.json")
];

// {
//   "id": "identify-dents-by-marking-with-an-x",
//   "section": "6. Body and Panel Condition",
//   "title": "Identify dents by marking with an \"X",
//   "type": "select_single",
//   "properties": {
//     "options": [
//       { "label": "Good", "value": "good" },
//       { "label": "Fault", "value": "fault" },
//       { "label": "N/A", "value": "not-applicable" }
//     ],
//     "has_notes": true,
//     "has_photos": true
//   },
//   "valid": {
//     "required": true
//   },
//   "pass": {
//     "value": "good"
//   }
// },
// {
//   "id": "identify-large-scratch-by-marking-with--",
//   "section": "6. Body and Panel Condition",
//   "title": "Identify large scratch by marking with \"-",
//   "type": "select_single",
//   "properties": {
//     "options": [
//       { "label": "Good", "value": "good" },
//       { "label": "Fault", "value": "fault" },
//       { "label": "N/A", "value": "not-applicable" }
//     ],
//     "has_notes": true,
//     "has_photos": true
//   },
//   "valid": {
//     "required": true
//   },
//   "pass": {
//     "value": "good"
//   }
// },
// {
//   "id": "identify-missingbroken-parts-with-an-o",
//   "section": "6. Body and Panel Condition",
//   "title": "Identify missing/broken parts with an \"O",
//   "type": "select_single",
//   "properties": {
//     "options": [
//       { "label": "Good", "value": "good" },
//       { "label": "Fault", "value": "fault" },
//       { "label": "N/A", "value": "not-applicable" }
//     ],
//     "has_notes": true,
//     "has_photos": true
//   },
//   "valid": {
//     "required": true
//   },
//   "pass": {
//     "value": "good"
//   }
// },
